package app.smartcoding.realrate.localization

import cafe.adriel.lyricist.LyricistStrings

@LyricistStrings(languageTag = "pt")
val PtStrings = Strings(
    analyzer = "Analisador",
    appreciationOverview = "Visão geral da valorização",
    chartLegendInterest = "Juros",
    chartLegendPrincipal = "Principal",
    chartXaxisMonths = "Meses",
    chartYaxisPayment = "Pagamento",
    code = "pt",
    costOfCredit = "Custo do Crédito",
    creditDealAnalyzerDescription = "Insira os detalhes do seu empréstimo para receber uma análise abrangente da sua oferta de crédito. Nosso analisador avalia as principais métricas para ajudá-lo a entender o custo real do seu empréstimo e tomar uma decisão informada.",
    detailsGoodRateLongTerm = "Boa taxa, mas o longo prazo resulta em alto custo total.",
    detailsHighApr = "TAEG alta. ",
    detailsHighInterestCost = "Alto custo total de juros.",
    detailsHighRateShortTerm = "Taxa alta, mas o curto prazo mantém o custo total baixo.",
    detailsLowApr = "TAEG baixa. ",
    detailsLowInterestCost = "Baixo custo total de juros.",
    discountsTradeIn = "Descontos / Troca",
    displayName = "Português",
    distribution = "Distribuição",
    downPayment = "Entrada",
    effectiveApr = "TAEG",
    headerBalance = "Saldo",
    headerDate = "Date",
    headerInterest = "Juros",
    headerMonth = "#",
    headerPayment = "Pagamento",
    headerPrincipal = "Principal",
    hideDetails = "Ocultar Detalhes",
    interest = "Juros",
    invalidData = "Dados Inválidos",
    loanAmountSupportingText = "O valor total do empréstimo, incluindo quaisquer custos adicionais.",
    loanDetails = "Detalhes do Empréstimo",
    paymentSupportingText = "Seu pagamento mensal estimado.",
    paymentComposition = "Composição do Pagamento",
    percentSymbol = "%",
    principal = "Principal",
    ratingBad = "Negócio Ruim",
    ratingExcellent = "Negócio Excelente",
    ratingFair = "Negócio Justo",
    ratingGood = "Bom Negócio",
    ratingPoor = "Negócio Pobre",
    schedule = "Cronograma",
    showDetails = "Mostrar Detalhes",
    summaryBad = "Muito desfavorável, evite si possível.",
    summaryExcellent = "Excelentes condições financeiras.",
    summaryFair = "Condições justas, considere negociar.",
    summaryGood = "Boas condições, padrão para o mercado.",
    summaryPoor = "Condições ruins, alto custo ou taxa.",
    totalPaid = "Total Pago",
    lockTaxRate = "Bloquear Taxa de Imposto",
    unlockTaxRate = "Desbloquear Taxa de Imposto",
    currencySymbol = "R$",
    currency = "Moeda",
    totalCreditAmount = "Valor Total do Crédito",
    taxAmount = "Valor do Imposto/Dedução",
    netAmountDisbursed = "Valor Líquido Desembolsado",
    years = "Anos",
    loanTermTotalMonths = "Prazo do Empréstimo (Meses)",
    monthlyInstallment = "Parcela Mensal",
    principalInstallment = "Parcela do Principal",
    otherFees = "Outras Taxas",
    insuranceCost = "Prêmio de Seguro",
    aprc = "Taxa Anual de Encargos Efetiva Global (TAEG)",
    totalAmountPayable = "Valor Total a Pagar",
    prepaidFeeFixed = "Taxa de Processamento (Valor Fixo)",
    prepaidFeePercentage = "Taxa de Processamento (Porcentagem)",
    months = "Meses",
    description = "Este analisador ajuda você a avaliar se uma oferta de empréstimo é favorável para você. Ao contrário das calculadoras padrão, não requer a inserção de uma taxa de juros. Em vez disso, calcula a TAEG e o custo total do crédito com base nos pagamentos e taxas, fornecendo uma classificação do negócio e gráficos detalhados.",
    agree = "Concordar",
    information = "Informação",
    errorCalculationOverflow = "A TAEG é muito alta, estouro de cálculo.",
    errorTotalPaymentIsLessThanLoanAmount = "O valor recebido é menor que o valor do empréstimo.",
    errorDivisionByZero = "Divisão por zero",
    errorNegativeResult = "Resultado negativo",
    errorRateTooHigh = "Taxa muito alta",
    errorCalculation = "Por favor, insira dados corretos",
    close = "Fechar",

    hi = "Olá",
    guest = "Convidado",
    account = "Conta",
    signInWithGoogle = "Entrar com o Google",
    signOut = "Sair",
    settings = "Configurações",
    about = "Sobre",
    privacyPolicy = "Política de Privacidade",
    termsOfService = "Termos de Serviço",
    language = "Idioma",

    theme = "Tema",
    light = "Claro",
    dark = "Escuro",
    system = "Sistema",
    toggleExpand = "Expandir/Recolher",
)
